document.addEventListener("DOMContentLoaded", function () {
  Shopify.queryParams = {};

  if (location.search.length) {
    var params = location.search.substr(1).split("&");

    for (var i = 0; i < params.length; i++) {
      var keyValue = params[i].split("=");
      var key = decodeURIComponent(keyValue[0]);
      var value = decodeURIComponent(keyValue[1]);

      if (keyValue.length) {
        if (Shopify.queryParams[key]) {
          Shopify.queryParams[key].push(value);
        } else {
          Shopify.queryParams[key] = [value];
        }
      }
    }
  }

  var sortBy = document.querySelector(".wrapper-select-sort-by select");
  sortBy.addEventListener("change", function (e) {
    var value = e.target.value;
    redirectUserOrderBy(value);
  });
});

function redirectUserOrderBy(value) {
  Shopify.queryParams.sort_by = value;
  location.search = decodeURIComponent(
    new URLSearchParams(Shopify.queryParams).toString()
  );
}
